import featureConfigs from "./featureConfigs";

export default function getCallConfigs(
  groups: string[],
  taskCreationSource?: string
) {
  const defaultCallConfig = {
    dispositions: "",
    script: "closer_qualified",
    transferGroupOptions: []
  };

  if (taskCreationSource == "outbound_dial") {
    defaultCallConfig.script = "closer_unqualified";
  }

  if (Array.isArray(groups)) {
    let config;
    const maxTier = 10;
    const configs = featureConfigs.getGroups(groups);
    if (configs.length == 1) {
      config = configs[0];
    }
    config = configs.sort((a: any, b: any) => {
      return (a.tier || maxTier) - (b.tier || maxTier);
    })[0];

    if (taskCreationSource && config && config.callConfigs) {
      if (config.callConfigs.hasOwnProperty(taskCreationSource)) {
        return config.callConfigs[taskCreationSource];
      } else {
        return config.callConfigs.default;
      }
    }
  }
  return defaultCallConfig;
}
